/*
=========================================================
* Material Kit 2 PRO React - v2.1.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Stack from "@mui/material/Stack";
import {Link as RouterLink} from 'react-router-dom';

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Coworking page component
import AboutUsOption from "pages/PaginaPrincipal/components/AboutUsOption";

function AboutUs() {
  return (
     <section id="about-us">
     <MKBox component="section" position="relative" py={6}>
      <Container sx={{ maxWidth: "100% !important" }}>
        <Grid container item xs={10} sx={{ mx: "auto" }}>
            <MKBox component="section" py={{ xs: 3, md: 12 }} variant="gradient" bgColor="light" borderRadius="lg" width="100%">
              <Container>
                <Grid container>
                  <Grid item xs={12} lg={5}>
                    <MKTypography variant="h3" my={1}>
                      Porque a FMP Soluções
                    </MKTypography>
                    <MKTypography variant="body2" color="text" mb={2}>
                      A FMP Soluções é uma empresa sempre em busca de inovações, e de formas únicas para melhorar o cenário tecnológico na América Latina. Nós temos na nossa cerne
                      o crescimento da região através da implementação de soluções que visem o fortalecimento da região, protegendo as suas nações, indústrias e indivíduos.
                    </MKTypography>
                    <MKTypography
                      component={RouterLink}
                      to="/pages/empresa/sobre-nos/"
                      variant="button"
                      color="info"
                      fontWeight="regular"
                      sx={{
                        width: "max-content",
                        display: "flex",
                        alignItems: "center",

                        "& .material-icons-round": {
                          fontSize: "1.125rem",
                          transform: "translateX(3px)",
                          transition: "transform 0.2s cubic-bezier(0.34, 1.61, 0.7, 1.3)",
                        },

                        "&:hover .material-icons-round, &:focus .material-icons-round": {
                          transform: "translateX(6px)",
                        },
                      }}
                    >
                      Mais sobre nós
                      <Icon sx={{ fontWeight: "bold" }}>arrow_forward</Icon>
                    </MKTypography>
                  </Grid>
                  <Grid item xs={12} lg={6} sx={{ ml: { xs: -2, lg: "auto" }, mt: { xs: 6, lg: 0 } }}>
                    <Stack>
                      <AboutUsOption
                        icon="mediation"
                        content={
                          <>
                            Soluções integradas e construídas para a sua necessidade.
                            <br />
                            Nossos consultores em parceria com o cliente para um resultado único.
                          </>
                        }
                      />
                      <AboutUsOption
                        icon="south_america"
                        content={
                          <>
                            Empresa nacional, com equipe especilizada em servir a América Latina.
                            <br />
                            Nossa missão é fortalecer a nossa região.
                          </>
                        }
                      />
                      <AboutUsOption
                        icon="token"
                        content={
                          <>
                            Fornecedores exclusivos, em toda América Latina, da MDC-SR10 V2, e 
                            <br />
                            software desenvolvido para perfeita integração com o data center.
                          </>
                        }
                      />
                    </Stack>
                  </Grid>
                </Grid>
              </Container>
            </MKBox>
          </Grid>
      </Container>
     </MKBox>
    </section>
  );
}

export default AboutUs;
